import { render } from "./rfp-iframe-loader.vue?vue&type=template&id=45218a7c"
import script from "./rfp-iframe-loader.vue?vue&type=script&lang=js"
export * from "./rfp-iframe-loader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__